import { Component, OnDestroy } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnDestroy {
  currentLanguage = '';
  subscription!: Subscription;

  constructor(private translate: TranslateService) {
    this.currentLanguage = this.translate.currentLang;
    this.subscription = this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.currentLanguage = params.lang;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
